// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1S30H","savePackageButton":"ClientWallet_savePackageButton__oz3Ul"};